import * as tslib_1 from "tslib";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import ScrollableContent from '../ScrollableContent';
import { PremiumAsset } from './PremiumAsset';
import s from './PcpPopover.scss';
var MAX_ASSETS_TO_SHOW = 2;
export var PremiumAssetList = function (_a) {
    var _b = _a.assets, assets = _b === void 0 ? [] : _b;
    var t = useTranslation().t;
    var _c = useState(false), isScrolledToBottom = _c[0], setScrolledToBottom = _c[1];
    var _d = useState(false), showAllAssets = _d[0], setShowAllAssets = _d[1];
    var hasOverflow = assets.length > MAX_ASSETS_TO_SHOW;
    var assetsToShow = showAllAssets
        ? assets
        : assets.slice(0, MAX_ASSETS_TO_SHOW);
    return (React.createElement("div", { className: classnames(s['pcp-asset-list'], hasOverflow && s['has-more'], isScrolledToBottom && s['bottomed']) },
        React.createElement(ScrollableContent, { wrapperClassName: s['list-wrap'], className: s['scrollable-list'], throttleTimeout: 300, onScrolled: function (scrollTop, distanceToBottom) {
                var isScrolledBottomNew = distanceToBottom < 2;
                if (isScrolledToBottom === isScrolledBottomNew) {
                    // let's only update state when something actually changed because things can get laggy
                    return;
                }
                setScrolledToBottom(isScrolledBottomNew);
            } },
            React.createElement("ul", { className: s['pcp-assets'] }, assetsToShow.map(function (asset) { return (React.createElement("li", { key: asset.filename, className: s['asset'] },
                React.createElement(PremiumAsset, tslib_1.__assign({}, asset)))); })),
            showAllAssets && React.createElement("div", { className: s['fade'] })),
        hasOverflow && (React.createElement("button", { className: s['show-more'], onClick: function () { return setShowAllAssets(!showAllAssets); } }, t(showAllAssets ? 'common.showLess' : 'common.showMore')))));
};
export default PremiumAssetList;
//# sourceMappingURL=PremiumAssetList.js.map